import { clsx } from 'clsx';

import type { PropsWithChildren } from 'react';

import styles from './Repeater.module.css';

export interface RepeaterProps {
  /** The direction of the items. */
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  /** The gap between the items. */
  gap?: '025' | '050' | '075' | '100' | '150' | '200';
}

/** Represents a component to show a list of items. */
export const Repeater = ({ children, flexDirection = 'column', gap = '050' }: PropsWithChildren<RepeaterProps>) => {
  return (
    <div className={clsx(styles['repeater'], styles[`repeater--${flexDirection}`], styles[`repeater--gap-${gap}`])}>
      {children}
    </div>
  );
};
